import { h, Fragment } from 'preact';
import { useMemo } from 'preact/hooks';
import { withCartContext } from './cart-context';
import Image from 'utils/image';
import { formatMoney } from 'utils/format-money';
import Icon from 'utils/icon';

const CartItem = (props) => {
  const { cart, line } = props;
  const { title, handle } = line.product;

  const adjustQuantity = (quantity) => {
    cart.update({
      id: line.id,
      quantity,
    });
  };

  const variants = line.product?.title.split('/');
  const tags = line.product?.tags;
  const lengthTag = tags.find(t => t.includes('length'))?.replace('length::', 'Length: ');
  const giftCard = tags.find(t => t.includes('Gift Card'));

  const strippedTitle = () => {
    const productTitle = title.split(':')[0] ? title.split(':')[0] : title;
    return productTitle;
  };

  const lineItem = useMemo(
    () => (
      <div
        key={line.id}
        className="px-[20px] py-[20px] border-b-1 border-grey-400 cart-item"
      >
        <div className="flex flex-row">
          <div className="w-[46%] aspect-[11/14]">
            <Image
              src={line.featured_image.url}
              alt={line.featured_image.alt}
              srcWidths={{ sm: 128, md: 256, lg: 512 }}
            />
          </div>
          <div className="w-[64%] pl-[13px] relative">
            <div className="title-and-price flex relative pb-[8px] lg:pb-[13px]">
              <a href={`/products/${handle}`} className="text-h6 w-[70%] text-s2">
                {strippedTitle()}
              </a>
              <span className="text-h6 font-medium w-[30%] text-right absolute right-0">
                {formatMoney({ amount: line.product.price }, true)}
                {line.product.compare_at_price && (
                  <del className="text-red py-[6px] block font-medium">
                    {formatMoney({
                      amount: line.product.compare_at_price,
                    }, true)}
                  </del>
                )}
              </span>
            </div>
            { !giftCard && (
              <div className="variants">
                {variants[1] && (
                  <span className="text-text-2 text-h7 block pb-[3px] lg:pb-[10px]">{variants[1]}</span>
                )}
                {variants[0] && (
                  <span className="text-text-2 text-h7 block pb-[3px] lg:pb-[10px]">
                    {TMW.Strings.cart.size} {variants[0]}
                  </span>
                )}
                {lengthTag && (
                  <span className="text-text-2 text-h7 block">{lengthTag}</span>
                )}
            </div>
            )}
            <div className="absolute flex items-center bottom-[0px]">
              <button
                onClick={() => adjustQuantity(line.quantity - 1)}
                ariaLabel={TMW.Strings.cart.remove}
                className="absolute left-[14px] h-[20px]"
              >
                <Icon id="minus" />
              </button>
              <input
                type="number"
                value={line.quantity}
                onBlur={(e) => adjustQuantity(parseInt(e.target.value, 10))}
                className="quantity-input w-[96px] rounded-[6px] border-1 border-grey-400 text-center text-s2"
              />
              <button
                onClick={() => adjustQuantity(line.quantity + 1)}
                ariaLabel={TMW.Strings.cart.add}
                className="absolute left-[70px] h-[20px]"
              >
                <Icon id="plus" />
              </button>
              <button
                onClick={() => cart.update({ id: line.id, quantity: 0 })}
                className="pl-[8px]"
              >
                <Icon id="remove" />
              </button>
            </div>
          </div>
        </div>
      </div>
    ),
    [line],
  );

  return lineItem;
};

export default withCartContext(CartItem);